var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:['button', 'is-primary', 'is-fullwidth', { 'is-loading': _vm.loading }],on:{"click":function($event){return _vm.createOnDemandSession(_vm.field)}}},[_vm._v("\n  "+_vm._s(_vm.buttonText)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }